import './ScopeSummary.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FileSearchOutlined } from '@ant-design/icons';
import { getClosestCardBody } from '@lib/popups';
import { InitiativeSubSection } from '../general/InitiativeSubSection';
import React from 'react';
import { SonarText } from '@ui/text';
import { useInitiativeScopeCounts } from '@hooks';
import { getSonarObjectTypeLabel, getSonarObjectTypeLabelPlural } from '@sonar-software/sonar-ts-lib';

function scrollToSection(sectionType: string): void {
	const target = document.getElementById(`scope-type-subsection-${sectionType}`);

	if (!target) {
		return;
	}

	const container = getClosestCardBody(target);

	if (!container) {
		return;
	}

	container.scrollTo({
		behavior: 'smooth',
		top: target.offsetTop
	});
}

export interface InitiativeScopeSummaryProps {
	initiativeId: number;
}

export const InitiativeScopeSummary: React.FC<InitiativeScopeSummaryProps> = ({ initiativeId }) => {
	const { counts, totalCount } = useInitiativeScopeCounts(initiativeId);

	if (!totalCount) {
		return null;
	}

	return (
		<InitiativeSubSection
			bold
			count={ totalCount }
			direction='horizontal'
			icon={ <FileSearchOutlined /> }
			id='initiative-scope-summary'
			title={ COPY_SPECIFIC.SCOPES }>
			{ counts.map(([ type, count ]) =>
				<SonarText
					className='scope-type-label'
					key={ type }
					link
					onClick={ () => scrollToSection(type) }>
					{ count } { count > 1 ? getSonarObjectTypeLabelPlural(type) : getSonarObjectTypeLabel(type) }
				</SonarText>) }
		</InitiativeSubSection>
	);
};
